import { Box, Button, Typography, Container, Grid, Paper, useTheme, IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PlotChart from "../components/plot-chart";
import {  School, AttachMoney, People, VisibilityOff, Visibility } from "@mui/icons-material";
import { useClassroomActions } from "../hooks/useClassroomActions";
import NavBarLayout from "../components/nav-bar-layout";

type HubOverview = {
  totalStudents: number;
  totalEarnings: number;
  totalClassrooms: number;
  enrollmentStat: {
    name: string;
    value: number;
  }[];
};


function Dashboard() {
    const navigate = useNavigate();

    const { classrooms, getHubOverview } = useClassroomActions();

    const [hubOverview, setHubOverview] = useState<HubOverview>({
        totalStudents: 0,
        totalEarnings: 0,
        totalClassrooms: 0,
        enrollmentStat: [],
    });


    const [showBalance, setShowBalance] = useState<boolean>(() => {
        const saved = localStorage.getItem('show-dashboard-balance');
        return saved !== null ? JSON.parse(saved) : true;
    });


    const toggleBalanceVisibility = () => {
        setShowBalance((prev) => {
            const newValue = !prev;
            localStorage.setItem('show-dashboard-balance', JSON.stringify(newValue));
            return newValue;
        });
    };

    
    useEffect(() => {
        const loadData = async () => {
            const overview = await getHubOverview();

            if (overview) {
                setHubOverview(overview);
            }
        };

        loadData();
    }, [classrooms]);

    if (!hubOverview) {
        
    }
    

   
    return (
        <NavBarLayout>

            <Grid container spacing={3}>

                 <Grid size={{ xs: 12, sm: 4, md: 6 }}>
                    <Paper
                        elevation={0}
                        sx={{
                        p: 3,
                        borderRadius: 4,
                        background: 'linear-gradient(135deg, #10b981 0%, #22c55e 100%)',
                        color: 'white',
                        position: 'relative',
                        overflow: 'hidden',
                        transition: 'transform 0.2s ease-in-out',
                        '&:hover': {
                            transform: 'translateY(-2px)',
                        },
                        '&::before': {
                            content: '""',
                            position: 'absolute',
                            top: 0,
                            right: 0,
                            width: '120px',
                            height: '120px',
                            background: 'rgba(255, 255, 255, 0.08)',
                            borderRadius: '50%',
                            transform: 'translate(40px, -40px)',
                        },
                        '&::after': {
                            content: '""',
                            position: 'absolute',
                            bottom: 0,
                            left: 0,
                            width: '80px',
                            height: '80px',
                            background: 'rgba(255, 255, 255, 0.05)',
                            borderRadius: '50%',
                            transform: 'translate(-20px, 20px)',
                        },
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'relative', zIndex: 1 }}>
                        <Box>
                            <Typography variant="h3" sx={{ fontWeight: 800, mb: 0.5, fontSize: { xs: '2rem', sm: '2.5rem' } }}>
                            {hubOverview.totalClassrooms}
                            </Typography>
                            <Typography variant="body1" sx={{ opacity: 0.9, fontWeight: 500 }}>
                            Total Classrooms
                            </Typography>
                        </Box>
                        <Box sx={{ 
                            p: 1.5, 
                            borderRadius: 2, 
                            backgroundColor: 'rgba(255, 255, 255, 0.15)',
                            backdropFilter: 'blur(10px)'
                        }}>
                            <School sx={{ fontSize: 32, opacity: 0.9 }} />
                        </Box>
                        </Box>
                    </Paper>
                </Grid>
                
                <Grid size={{ xs: 12, sm: 4, md: 6 }}>
                    <Paper
                        elevation={0}
                        sx={{
                            p: 3,
                            borderRadius: 4,
                            background: 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)',
                            color: 'white',
                            position: 'relative',
                            overflow: 'hidden',
                            transition: 'transform 0.2s ease-in-out',
                            '&:hover': {
                                transform: 'translateY(-2px)',
                            },
                            '&::before': {
                                content: '""',
                                position: 'absolute',
                                top: 0,
                                right: 0,
                                width: '120px',
                                height: '120px',
                                background: 'rgba(255, 255, 255, 0.08)',
                                borderRadius: '50%',
                                transform: 'translate(40px, -40px)',
                            },
                            '&::after': {
                                content: '""',
                                position: 'absolute',
                                bottom: 0,
                                left: 0,
                                width: '80px',
                                height: '80px',
                                background: 'rgba(255, 255, 255, 0.05)',
                                borderRadius: '50%',
                                transform: 'translate(-20px, 20px)',
                            },
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'relative', zIndex: 1 }}>
                            <Box>
                                <Typography variant="h3" sx={{ fontWeight: 800, mb: 0.5, fontSize: { xs: '2rem', sm: '2.5rem' } }}>
                                    {hubOverview.totalStudents}
                                </Typography>
                                <Typography variant="body1" sx={{ opacity: 0.9, fontWeight: 500 }}>
                                    Total Students
                                </Typography>
                            </Box>
                            <Box sx={{ 
                                p: 1.5, 
                                borderRadius: 2, 
                                backgroundColor: 'rgba(255, 255, 255, 0.15)',
                                backdropFilter: 'blur(10px)'
                            }}>
                                <People sx={{ fontSize: 32, opacity: 0.9 }} />
                            </Box>
                        </Box>
                    </Paper>
                </Grid>

                 

                <Grid size={{ xs: 12, sm: 4, md: 6 }}>
                    <Paper
                        elevation={0}
                        sx={{
                            p: 3,
                            borderRadius: 4,
                            background: 'linear-gradient(135deg, #06b6d4 0%, #3b82f6 100%)',
                            color: 'white',
                            position: 'relative',
                            overflow: 'hidden',
                            transition: 'transform 0.2s ease-in-out',
                            '&:hover': {
                                transform: 'translateY(-2px)',
                            },
                            '&::before': {
                                content: '""',
                                position: 'absolute',
                                top: 0,
                                right: 0,
                                width: '120px',
                                height: '120px',
                                background: 'rgba(255, 255, 255, 0.08)',
                                borderRadius: '50%',
                                transform: 'translate(40px, -40px)',
                            },
                            '&::after': {
                                content: '""',
                                position: 'absolute',
                                bottom: 0,
                                left: 0,
                                width: '80px',
                                height: '80px',
                                background: 'rgba(255, 255, 255, 0.05)',
                                borderRadius: '50%',
                                transform: 'translate(-20px, 20px)',
                            },
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'relative', zIndex: 1 }}>
                            <Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 0.5 }}>
                                    <Typography variant="h3" sx={{ fontWeight: 800, fontSize: { xs: '2rem', sm: '2.5rem' } }}>
                                        {showBalance ? `₦${hubOverview.totalEarnings.toLocaleString()}` : '••••••'}
                                    </Typography>
                                    <IconButton
                                        onClick={toggleBalanceVisibility}
                                        size="small"
                                        sx={{ 
                                            color: 'white', 
                                            opacity: 0.8,
                                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                            '&:hover': {
                                                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                                                opacity: 1,
                                            }
                                        }}
                                    >
                                        {showBalance ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                                    </IconButton>
                                </Box>
                                <Typography variant="body1" sx={{ opacity: 0.9, fontWeight: 500 }}>
                                    Total Earnings
                                </Typography>
                            </Box>
                            <Box sx={{ 
                                p: 1.5, 
                                borderRadius: 2, 
                                backgroundColor: 'rgba(255, 255, 255, 0.15)',
                                backdropFilter: 'blur(10px)'
                            }}>
                                <AttachMoney sx={{ fontSize: 32, opacity: 0.9 }} />
                            </Box>
                        </Box>
                    </Paper>
                </Grid>                         

              

            </Grid>
        


            <Paper
                elevation={0}
                sx={{
                    p: { xs: 2, sm: 3, md: 4 },
                    borderRadius: 3,
                    backgroundColor: 'white',
                    border: '1px solid #e2e8f0',
                    mb: 4,
                    marginTop: 3
                }}
            >
                {/* Chart Container with perfect centering */}
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                        minHeight: { xs: 300, sm: 400, md: 500 },
                        '& > *': {
                            width: '100%',
                            maxWidth: { xs: '100%', sm: 600, md: 800, lg: 1000 },
                            height: { xs: 300, sm: 400, md: 500 },
                        },
                    }}
                >
                    <PlotChart data={hubOverview.enrollmentStat} />
                </Box>
            </Paper>

        </NavBarLayout>
    );
}

export default Dashboard;